<template>
  <f7-row no-gap class="mb-05 pb-05 pt-05 pl-05 pr-05">
    <f7-col width="35" class="p-0">
      <small>{{ source.timestamp | moment('YYYY-MM-DD HH:mm:ss') }}</small>
    </f7-col>
    <f7-col width="20" class="text-align-left p-0">
      <small>{{ source.reward / config.point | numeral(config.numeral) }}</small>
    </f7-col>
    <f7-col class="text-align-center p-0">
      <small>{{ source.immature ? 'Immature' : 'Matured' }}</small>
    </f7-col>
    <f7-col width="20" class="text-align-right p-0">
      <small>{{ source.percent | numeral('0.000000') }} %&nbsp;&nbsp;</small>
    </f7-col>
  </f7-row>
</template>
<style scoped>
small {
  font-size : 9px;
}
small.xs {
  font-size : 8px;
}
</style>
<script>
import { f7Row, f7Col } from 'framework7-vue';

export default {
  components: {
    f7Row,
    f7Col
  },
  props: {
    source: {
      type: Object,
      default() {
        return {}
      }
    },
    config: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
</script>
